import type { CaptureChallenge, CaptureProfileContract } from '@ipc/shared'
import type { Translate } from '../../types'
import { timed } from './timed'

export { TriggerError } from './error'

/**
 * What a trigger is given. It returns exactly `profile.frames` pictures, or throws a `TriggerError`.
 * `say` shows a line under the picture (the challenge prompt); it is cleared by the screen when the trigger ends.
 */
export interface TriggerContext {
  video: HTMLVideoElement
  /** One picture, already encoded as the profile says (JPEG or PNG, mirrored when asked). */
  grab(): Promise<Blob>
  profile: CaptureProfileContract
  /** The direction chosen by the server, or null. Only the motion trigger shows it. */
  challenge: CaptureChallenge | null
  t: Translate
  signal: AbortSignal
  say?: (text: string | null) => void
}

export type Trigger = (ctx: TriggerContext) => Promise<Blob[]>

/**
 * The triggers this build has, keyed by `profile.secondFrame`. A profile asking for a trigger that is not here is a
 * technical error (the page does not guess). Task 22 adds `motion` with one line.
 */
export const TRIGGERS: Record<string, Trigger> = {
  timed,
  motion: (ctx) => import('./motion').then((m) => m.motion(ctx)), // T22: BioID motion trigger (lazy chunk)
}
